import React, { Component } from "react"
import { Link } from "gatsby"
import { css } from "emotion"

class HeaderLinks extends Component {
  render() {
    return (
      <>
        <Link to="/about-us" activeClassName="current-page">
          About
        </Link>
        <Link to="/recipes" activeClassName="current-page">
          Recipes
        </Link>
        <Link to="/reviews" activeClassName="current-page">
          Reviews
        </Link>
      </>
    )
  }
}

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isActive: false,
    }
    this.openMobileMenu = this.openMobileMenu.bind(this)
  }

  openMobileMenu() {
    this.setState({ isActive: !this.state.isActive })
    document.body.classList.toggle("menuopen")
  }

  render() {
    return (
      <>
        <header
          className={css`
            background-color: #fff;
            transition: all 0.5s;
            box-shadow: -21.213px 21.213px 30px 0px rgba(158, 158, 158, 0.3);
            position: relative;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;

            @media (min-width: 400px) {
              flex-flow: column nowrap;
            }

            @media (min-width: 600px) {
              flex-flow: row nowrap;
            }
          `}
        >
          <Link
            to="/"
            className={css`
              flex: 0 1 20%;
            `}
          >
            <img
              className={css`
                margin: 5px 10px;
              `}
              src="/resources/images/online-cake-clasess-logo.png"
              alt="Online Cake Classes"
            />
          </Link>
          <nav
            className={css`
              flex: 0 1 80%;
              display: flex;
              flex-flow: row wrap;
              justify-content: flex-end;

              @media (min-width: 100px) {
                a {
                  display: none;
                }
              }

              @media (min-width: 769px) {
                a {
                  display: block;
                }
              }

              a {
                color: rgba(0, 0, 0, 0.7);
                font-size: 20px;
                text-decoration: none;
                padding: 30px 12px;
                position: relative;
                transition: 0.5s;

                &.current-page {
                  color: #000;
                  &:after {
                    opacity: 1;
                    transform: translate3d(0, 0, 0);
                  }
                }

                &:hover {
                  &:after {
                    opacity: 1;
                    transform: translate3d(0, 0, 0);
                  }
                }

                &:after {
                  position: absolute;
                  bottom: 10px;
                  left: 0;
                  right: 0;
                  content: "";
                  width: 60%;
                  height: 2px;
                  background: #be0f0e;
                  margin: 0 auto;
                  opacity: 0;
                  transform: translate3d(0, -10px, 0);
                }
              }
            `}
          >
            <HeaderLinks />
            <button
              onClick={this.openMobileMenu}
              className={css`
                 {
                  @media (min-width: 769px) {
                    display: none;
                  }
                  position: absolute;
                  top: 0px;
                  right: 20px;
                  z-index: 150;
                  color: blue;
                  background-color: ${this.state.isActive ? "red" : "#fff"};
                  color: ${this.state.isActive ? "#fff" : "#000"};
                  border: ${this.state.isActive ? "none" : "solid 1px #ddd"};
                  width: 40px;
                  height: 40px;
                  margin-top: 20px;
                  margin-right: 5px;
                }
              `}
            >
              {this.state.isActive ? "X" : "="}
            </button>
          </nav>
        </header>

        <nav
          className={css`
            display: ${this.state.isActive ? `block` : `none`};
            position: fixed;
            z-index: 100;
            width: 250px;
            background: rgba(0, 0, 0, 0.7);
            top: 0;
            bottom: 0;
            right: 0;
            padding: 75px 40px 40px 40px;
            overflow: auto;
            transition: 0.5s;

            a {
              display: block;
              padding-bottom: 10px;
              margin-bottom: 10px;
              color: #fff;
              text-decoration: none;

              &.current-page {
                border-bottom: solid 1px #be0f0e;
              }
            }
          `}
        >
          <HeaderLinks />
        </nav>
      </>
    )
  }
}

export default Header
